import { AddressesPage } from '@pages/personal/addresses'
import { FavoritesPage } from '@pages/personal/favorites'
import { LoyaltyPage } from '@pages/personal/loyalty'
import { OfflineOrdersPage } from '@pages/personal/offline-orders'
import { OnlineOrdersPage } from '@pages/personal/online-orders'
import { PaymentPage } from '@pages/personal/payment'
// import { ReviewsPage } from "@pages/personal/reviews";

import { URL_CUSTOMER_ADDRESSES, URL_CUSTOMER_FAVORITES, URL_CUSTOMER_LOYALTY, URL_CUSTOMER_OFFLINE_ORDERS, URL_CUSTOMER_ORDERS, URL_CUSTOMER_PAYMENT } from '@shared/contants'

export interface PersonalRoute {
  path: string;
  element: React.ReactNode;
}

export const personalRoutes: PersonalRoute[] = [
  {
    path: URL_CUSTOMER_LOYALTY,
    element: <LoyaltyPage />,
  },
  {
    path: URL_CUSTOMER_ORDERS,
    element: <OnlineOrdersPage />,
  },

  {
    path: URL_CUSTOMER_OFFLINE_ORDERS,
    element: <OfflineOrdersPage />,
  },
  {
    path: URL_CUSTOMER_FAVORITES,
    element: <FavoritesPage />,
  },
  // {
  //   path: "reviews",
  //   element: <ReviewsPage />,
  // },
  // временно скрыта страница отзывов

  {
    path: URL_CUSTOMER_ADDRESSES,
    element: <AddressesPage />,
  },
  {
    path: URL_CUSTOMER_PAYMENT,
    element: <PaymentPage />,
  },
]
